import { DraggedApplianceState } from './draggedAppliance.type';

import { RootState } from '~/redux/store';

export const selectDraggedAppliance = ({
  draggedAppliance,
}: RootState): DraggedApplianceState => draggedAppliance;
